(function () {
  function init(root) {
    if (!root) return;

    var track = root.querySelector('[data-mnl-track]');
    var prev = root.querySelector('.mnl-subcoll__btn--prev');
    var next = root.querySelector('.mnl-subcoll__btn--next');
    if (!track) return;

    function step() {
      return Math.min(420, Math.floor(track.clientWidth * 0.9));
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;

      // nothing to scroll
      if (maxScroll <= 0) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    // initial state
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-mnl-subcoll-root]').forEach(init);
  }

  // First load
  document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container) return;
    container.querySelectorAll('[data-mnl-subcoll-root]').forEach(init);
  });
})();